export default __webpack_public_path__ + "static/media/grid.fe0f62a7.svg";